<template>
  <div>
    <h5 class="mb-3">Please enter a valid MEDPadala code and PIN</h5>
    <b-form-group :label="medPadalaCustomization.auth_labels.text1.label">
      <b-form-input
        v-model="code"
        :placeholder="medPadalaCustomization.auth_labels.text1.hint"
        :maxlength="medPadalaCustomization.auth_labels.text1.limit"
        :type="medPadalaCustomization.auth_labels.text1.inputType"
        :state="isValid('code')"
      >
      </b-form-input>
      <b-form-invalid-feedback :state="isValid('code')">
        {{ errorMessage("code") }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group :label="medPadalaCustomization.auth_labels.text2.label">
      <b-form-input
        v-model="pin"
        :placeholder="medPadalaCustomization.auth_labels.text2.hint"
        :type="
          medPadalaCustomization.auth_labels.text2.inputType.includes(
            'Password'
          )
            ? 'password'
            : 'text'
        "
        :maxlength="medPadalaCustomization.auth_labels.text2.limit"
        pattern="[0-9]*"
        inputmode="numeric"
        @keydown.native="isNumber($event)"
        @keyup.native="trimNumber('pin')"
        id="pin"
        :state="isValid('pin')"
      >
      </b-form-input>
      <b-form-invalid-feedback :state="isValid('pin')">
        {{ errorMessage("pin") }}
      </b-form-invalid-feedback>
      <b-form-input
        type="text"
        hidden
        :state="medPadalaErrors && medPadalaErrors.message === ''"
      ></b-form-input>
      <b-form-invalid-feedback
        v-if="medPadalaErrors && medPadalaErrors.message !== ''"
        :state="medPadalaErrors && medPadalaErrors.message === ''"
      >
        {{ medPadalaErrors.message }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group class="py-3">
      <b-button
        type="submit"
        :disabled="isDisabledSubmit || medPadalaLoading"
        block
        pill
        class="border-0 py-2 text-uppercase"
        variant="primary"
        :style="{
          backgroundColor:
            webDesign && webDesign.design && !isDisabledSubmit
              ? `${webDesign.design.main_color} !important`
              : null,
          color:
            webDesign && webDesign.design && !isDisabledSubmit
              ? `${webDesign.design.button_text_color} !important`
              : null
        }"
        id="submit-code-pin"
        @click="submitCodeAndPin"
      >
        Submit
      </b-button>
    </b-form-group>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import { ls } from "@/utilities";

export default {
  name: "MEDPadalaCodeAndPIN",
  computed: {
    ...mapState("estore", {
      webDesign: state => state.webDesign
    }),
    ...mapState("merchant", {
      customerPortalToken: state => state.customerPortalToken
    }),
    ...mapGetters({
      medPadalaLoading: "medpadala/medPadalaLoading",
      medPadalaErrors: "medpadala/medPadalaErrors",
      medPadalaCustomization: "medpadala/medPadalaCustomization"
    }),
    ...mapFields("medpadala", ["code", "pin", "medPadalaStep"]),
    isDisabledSubmit() {
      return !this.code || !this.pin;
    }
  },
  methods: {
    ...mapActions({
      medPadalaBalanceInquiry: "estore/medPadalaBalanceInquiry"
    }),
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      // const maxlength = evt.target.getAttribute("id") === "pin" ? 10 : 4;
      const maxlength = 4;
      const fieldLength = evt.target.value.length;
      if (
        (charCode >= 48 && charCode <= 57 && fieldLength < maxlength) ||
        charCode === 8
      ) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    trimNumber: function(ref) {
      this.$nextTick(() => {
        this[ref] = this[ref].replace(/\D/g, "");
      });
    },
    async submitCodeAndPin() {
      ls.set("MEDPadalaPin", this.pin);
      const request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken
        },
        payload: {
          code: this.code,
          pin: this.pin
        }
      };
      await this.medPadalaBalanceInquiry(request).then(() => {
        if (this.medPadalaErrors === null) {
          this.medPadalaStep = 2;
        }
      });
    },
    errorMessage: function(field) {
      if (this.medPadalaErrors == null) {
        return "";
      }
      return this.medPadalaErrors[field];
    },
    isValid: function(field) {
      if (this.medPadalaErrors == null) {
        return null;
      }
      return this.medPadalaErrors[field] ? false : null;
    }
  }
};
</script>

<style lang="scss" scoped>
#submit-code-pin:disabled {
  background-color: #d8dcde !important;
  color: #68737d !important;
}
</style>
